import React from 'react';
import { connect } from 'dva';
import { modelUtils, Storage, jsonToString } from '../../../utils'
import { Spin } from 'antd'
import { utils_tool, component_tool, framework_tool } from '../../../tool'
let { WizButton } = component_tool
let { WizContainer } = framework_tool
class Dynamic extends WizContainer {

  componentName = 'Dynamic';

  constructor(props) {
    super(props);
    this.buildActionKey();
    this.state = {
    }
  }

  propsAndStateOnChange = {
    testLogin: this._testLogin.bind(this)
  }

  _testLogin(nextProps, nextState) {
    let { testLogin } = nextProps;
    if (testLogin) {
      let { code, msg, token, data } = testLogin;
      if (code === 1) {
        wizNotice.success('请求成功：' + msg);
        nextState['result'] = data;
        return true;
      } else {
        wizNotice.error('请求失败：' + msg);
        return false;
      }
    }
    return false;
  }

  _onclick() {
    this.doAction({
      path: 'testLogin/doLogin',//'testLogin/doLogin',//personPathReport/getPersonPathReport
      payload: {
        key: 'testLogin',
        apiParams: { name: 'lilei', 'page.current': 1 }
      },
    })
  }


  render() {
    let { testLoginLoading } = this.props;
    let { result } = this.state;
    let stateView = !result ? null : <div>{jsonToString(result)}</div>
    return (
      <Spin tip={'加载中'} spinning={testLoginLoading}>
        <WizButton
          size="large"
          type="primary"
          onClick={() => { this._onclick() }}
        >
          请求
        </WizButton>
        {stateView}
      </Spin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { testLogin } = state;
  const test = modelUtils.getModelEntity(testLogin, 'testLogin');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'testLogin')
  return {
    testLogin: test,
    ...load
  };
};

export default connect(mapStateToProps)(Dynamic);
